import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'app.components.WxExportApplicantModal.title',
    defaultMessage: 'Create or sync worker profile',
    description:
      'Modal title for synchronizing applicant profiles to worker profiles',
  },
  body: {
    id: 'app.components.WxExportApplicantModal.body',
    defaultMessage:
      'This will create or sync {count} applicant profiles to worker profiles. New applicants will be created as workers, and existing workers will be updated. Depending on your configuration, this may trigger worker profile-related actions, such as onboarding flows and communications.',
    description:
      'Explains that applicant profiles create or update worker profiles and may trigger worker profile actions',
  },
  send: {
    id: 'app.components.WxExportApplicantModal.sendWebhook',
    defaultMessage: 'Create/sync worker profile',
    description:
      'Confirms synchronizing selected applicant profiles to worker profiles',
  },
  submissionSuccess: {
    id: 'app.components.WxExportApplicantModal.submissionSuccess',
    defaultMessage: 'Successfully submitted applicants for onboarding',
  },
  submissionError: {
    id: 'app.components.WxExportApplicantModal.submissionError',
    defaultMessage:
      'An error occurred while submitting applicants for onboarding',
  },
});
